import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ZoneDetailsForm from '../components/add-edit-zone/ZoneDetailsForm';
import ZoneSopsTab from '../components/add-edit-zone/ZoneSopsTab';
import ZoneAttachmentsTab from '../components/add-edit-zone/ZoneAttachmentsTab';

export const ZONE_MENU_KEYS = { DETAILS: 'details', SOPS: 'sops', ATTACHMENTS: 'attachments' };

export const ZONE_MENU_ITEMS = [
  {
    key: ZONE_MENU_KEYS.DETAILS,
    label: 'Zone Details',
    icon: MapOutlinedIcon,
    content: ZoneDetailsForm,
  },
  { key: ZONE_MENU_KEYS.SOPS, label: 'SOPs', icon: AssignmentOutlinedIcon, content: ZoneSopsTab },
  {
    key: ZONE_MENU_KEYS.ATTACHMENTS,
    label: 'Attachments',
    icon: AttachFileIcon,
    content: ZoneAttachmentsTab,
  },
];
export const ZONE_SIDEBAR_GROUPS = [{ key: 'zone', label: 'Zone', items: ZONE_MENU_ITEMS }];
